import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { useDesksConfigsParams } from './configsParamsProvider';
import { useDesksSettingsQuery } from '../../../../api/desksSettings';
import { deskNamesSelectors, useDeskNamesQuery } from '../../../../api/desk';
import { mapDesksConfigsToForm } from '../../../../services/acceptancePayloadMapper';
import { Collection } from './configsCollection';
import { useTimeIntervals } from '../../../../services/timeIntervals';

const Context = createContext();

export const useDesksConfigs = () => useContext(Context);

export const DesksConfigsProvider = ({ children }) => {
  const { acceptanceId, serviceCompanyId } = useDesksConfigsParams();

  const { data: settings, remove: removeSettingsCache } = useDesksSettingsQuery(
    {
      params: { acceptanceId },
    }
  );

  const { data: desksMap } = useDeskNamesQuery({
    params: { serviceCompanyId },
    options: { select: deskNamesSelectors.toMap },
  });

  const timeIntervals = useTimeIntervals();

  const collection = useMemo(() => {
    const preparedSettings =
      settings && desksMap && timeIntervals
        ? mapDesksConfigsToForm(settings, {
            desksMap,
            timeIntervals,
          })
        : [];

    return new Collection(preparedSettings);
  }, [settings, desksMap, timeIntervals]);

  useEffect(() => {
    return removeSettingsCache;
  }, [removeSettingsCache]);

  return <Context.Provider value={collection}>{children}</Context.Provider>;
};
